// src/features/organizations/organizationsSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// Create thunks with dependency injection for axios
// This allows us to use the axios instance from AuthContext
export const fetchOrgDetails = createAsyncThunk(
  'organizations/fetchOrgDetails',
  async ({ orgId, axiosInstance }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/organizations/api/org/${orgId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch organization details');
    }
  }
);

export const fetchOrganizationsByParent = createAsyncThunk(
  'organizations/fetchOrganizationsByParent',
  async ({ parentOrgId, axiosInstance }, { rejectWithValue }) => {
    try {
      const response = await axiosInstance.get(`/organizations/api/org/parentOrg/${parentOrgId}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || 'Failed to fetch organizations');
    }
  }
);

const organizationsSlice = createSlice({
  name: 'organizations',
  initialState: {
    currentOrgId: null,
    currentOrgDetails: {},
    allOrganizations: [],
    parentOrgId: 'd66fdc39-c4c0-4552-9a32-f8cc41fc940b', // Default parent org ID
    status: 'idle', // 'idle' | 'loading' | 'succeeded' | 'failed'
    error: null
  },
  reducers: {
    setCurrentOrgId: (state, action) => {
      state.currentOrgId = action.payload;
    },
    setParentOrgId: (state, action) => {
      state.parentOrgId = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // Handle fetch organization details states
      .addCase(fetchOrgDetails.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrgDetails.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.currentOrgDetails = action.payload;
      })
      .addCase(fetchOrgDetails.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      })
      
      // Handle fetch organizations by parent states
      .addCase(fetchOrganizationsByParent.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchOrganizationsByParent.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.allOrganizations = action.payload;
        
        // If currentOrgId is not set or not in the list, set it to the first org
        if (!state.currentOrgId || !action.payload.find(org => org.orgId === state.currentOrgId)) {
          state.currentOrgId = action.payload[0]?.orgId || null;
        }
      })
      .addCase(fetchOrganizationsByParent.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  }
});

export const { setCurrentOrgId, setParentOrgId } = organizationsSlice.actions;

export default organizationsSlice.reducer;